import { Box } from '@chakra-ui/react'
import ImpactoMap from 'components/tools/ImpactoMap'

export default function CitizenPortalMap() {
  // const boaVistaTestPins = [
  //   {
  //     id: 'rest_1',
  //     lat: 2.8235,
  //     lon: -60.6758,
  //     type: 'restaurant',
  //     data: {
  //       name: 'Churrascaria Búfalo Branco',
  //       category: 'Churrascaria',
  //       rating: 4.5,
  //       address: 'Centro - Boa Vista/RR',
  //       description: 'Rodízio tradicional com carnes regionais.',
  //     },
  //   },
  //   {
  //     id: 'event_1',
  //     lat: 2.819,
  //     lon: -60.673,
  //     type: 'event',
  //     data: {
  //       name: 'Festival Cultural de Boa Vista',
  //       date: '2026-04-15',
  //       location: 'Praça do Centro Cívico',
  //       description: 'Evento com música, gastronomia e cultura regional.',
  //     },
  //   },
  //   {
  //     id: 'unified_person_1',
  //     lat: 2.8102,
  //     lon: -60.6985,
  //     type: 'unified_person',
  //     data: {
  //       name: 'Arthur Melo',
  //       role: 'Colecionador TCG',
  //       bio: 'Entusiasta de tecnologia e jogos.',
  //     },
  //   },
  //   {
  //     id: 'rest_2',
  //     lat: 2.8059,
  //     lon: -60.6905,
  //     type: 'restaurant',
  //     data: {
  //       name: 'Tacacá da Dona Maria',
  //       category: 'Comida regional',
  //       rating: 4.7,
  //       address: 'Bairro São Francisco - Boa Vista/RR',
  //       description: 'Especialidade em pratos típicos amazônicos.',
  //     },
  //   },
  //   {
  //     id: 'event_2',
  //     lat: 2.8342,
  //     lon: -60.7001,
  //     type: 'event',
  //     data: {
  //       name: 'Feira do Produtor Rural',
  //       date: '2026-05-02',
  //       location: 'Parque Anauá',
  //       description: 'Produtos locais, artesanato e comidas típicas.',
  //     },
  //   },
  //   {
  //     id: 'unified_person_2',
  //     lat: 2.8182953419899377,
  //     lon: -60.665296425297704,
  //     type: 'unified_person',
  //     data: {
  //       name: 'Arthur Melo',
  //       role: 'Colecionador TCG',
  //       bio: 'Entusiasta de tecnologia e jogos.',
  //     },
  //   },
  // ]

  return (
    <Box h="100vh">
      <ImpactoMap
        simpleBaseLayerToogleButton={true}
        defaultBaseLayerSourceName="XYZ"
        // defaultPins={boaVistaTestPins}
        // selectionMode="STATIC_POINTER_IN_THE_CENTER"
        markingDataCard={false}
      />
    </Box>
  )
}
